import { observer } from 'mobx-react-lite'
import { BulkActionJobErrorDialogContainer } from '@/features/jobs/list/components/BulkActionJobErrorDialog/BulkActionJobErrorDialogContainer'
import { BulkCopyJobsDialogContainer } from '@/features/jobs/list/components/BulkCopyJobsDialog/BulkCopyJobsDialogContainer'
import { BulkCopyJobsSuccessDialogContainer } from '@/features/jobs/list/components/BulkCopyJobsSuccessDialog/BulkCopyJobsSuccessDialogContainer'
import { TransferJobDialogContainer } from '@/features/jobs/TransferJobDialog/TransferJobDialogContainer'
import { NotifyProsOfUnclaimedJobsDialogContainer } from '@/features/jobs/list/components/JobManagement/NotifyProsOfUnclaimedJobsDialog/NotifyProsOfUnclaimedJobsDialogContainer'
import { AdvanceJobsDialogContainer } from '@/features/jobs/list/components/AdvanceJobsDialog/AdvanceJobsDialogContainer'
import { type JobManagementViewModel } from '@/features/jobs/list/JobManagementViewModel'

export interface JobManagementDialogsContainerProps {
  vm: JobManagementViewModel
}

/**
 * The dialogs of the job list's bulk actions.
 */
export const JobManagementDialogsContainer = observer(
  function JobManagementDialogsContainer({
    vm,
  }: JobManagementDialogsContainerProps) {
    return (
      <>
        <BulkCopyJobsDialogContainer vm={vm.selectionVm.bulkCopyVm} />
        <TransferJobDialogContainer vm={vm.selectionVm.transferJobVm} />
        <BulkActionJobErrorDialogContainer
          vm={vm.selectionVm.bulkActionErrorVm}
        />
        <BulkCopyJobsSuccessDialogContainer
          vm={vm.selectionVm.bulkCopyJobsSuccessVm}
        />
        <NotifyProsOfUnclaimedJobsDialogContainer
          vm={vm.notifyProsOfUnclaimedJobsVm}
        />
        <AdvanceJobsDialogContainer vm={vm.selectionVm.advanceJobsVm} />
      </>
    )
  },
)
